"use client";

import React from "react";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
  errorClassName?: string;
  label?: string | React.ReactNode;
  labelClassName?: string;
  requiredField?: boolean;
  reserveErrorSpace?: boolean;
}

const Input: React.FC<InputProps> = ({
  error,
  errorClassName = "",
  label,
  labelClassName = "",
  requiredField = false,
  reserveErrorSpace = true,
  className = "",
  id,
  "aria-invalid": ariaInvalidProp,
  "aria-describedby": ariaDescribedByProp,
  ...props
}) => {
  const errorId = id && error ? `${id}-error` : undefined;
  const describedBy = [ariaDescribedByProp, errorId].filter(Boolean).join(" ") || undefined;

  return (
    <div className="w-full">
      {label && (
        <label
          htmlFor={id}
          className={`mb-1 block font-open-sans text-xs sm:text-sm font-medium text-slate-700 dark:text-slate-200 ${labelClassName}`}
        >
          {label}
          {(requiredField || props.required) && (
            <span className="ml-1 text-red-500">*</span>
          )}
        </label>
      )}

      <input
        id={id}
        {...props}
        aria-invalid={ariaInvalidProp ?? Boolean(error)}
        aria-describedby={describedBy}
        className={`h-14 w-full rounded-md border-0 border-b-2 bg-white px-4 py-3 font-open-sans text-sm text-slate-900 outline-none transition-colors placeholder:font-open-sans placeholder:text-sm placeholder:text-slate-400 dark:bg-gray-900 dark:text-slate-100 dark:placeholder:text-slate-500 ${error
            ? "border-gray-200"
            : "border-gray-200 dark:border-gray-700"
          } ${className}`}
      />

      {reserveErrorSpace ? (
        <div className="">
          {error && (
            <p id={errorId} role="alert" className={`mt-1 font-open-sans text-xs sm:text-sm leading-4 text-red-500 ${errorClassName}`}>
              {error}
            </p>
          )}
        </div>
      ) : error ? (
        <p id={errorId} role="alert" className={`mt-1 font-open-sans text-xs sm:text-sm leading-4 text-red-500 ${errorClassName}`}>
          {error}
        </p>
      ) : null}
    </div>
  );
};

export default Input;
